import { type FunctionComponent } from 'react';
import { SMALL_MAX_PX, MEDIUM_MAX_PX } from '../../../../constants/breakpoints';
import { SHOWROOM_MARBLE_BACKGROUND_PUBLIC_ID } from '../../../../constants/showroom';
import { type Variation } from '../../../../helpers/images/images.helper';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';

export const ShowroomExperienceBackground: FunctionComponent<{ blurBothEnds?: boolean }> = ({ blurBothEnds = false }) => {
	const variations: Variation[] = [
		{ mediaCondition: { maxWidth: SMALL_MAX_PX }, options: { width: 430, height: 2074, crop: 'fill' } },
		{ mediaCondition: { maxWidth: MEDIUM_MAX_PX }, options: { width: 768, height: 2074, crop: 'fill' } }
	];
	const backgroundGradient = blurBothEnds
		? 'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 20%, rgba(255,255,255,0) 80%, rgba(255,255,255,1) 100%)'
		: 'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)';

	return (
		<div className="absolute bottom-0 w-100 h-100" data-testid="showroom-experience-background">
			<div
				className="absolute top-0 w-100 h-100"
				style={{
					backgroundImage: backgroundGradient,
					zIndex: 1
				}}
			/>
			<CloudinaryImage
				publicID={SHOWROOM_MARBLE_BACKGROUND_PUBLIC_ID}
				options={{ width: 4000, height: 2074, crop: 'fill' }}
				description="showroom experience background"
				className="absolute bottom-0 h-100 w-100 object-cover"
				useDimensions={false}
				variations={variations}
			/>
		</div>
	);
};
